import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import classNames from 'classnames';

const YoungAgeScreen = ({ backButtonClick, isDarkMode = false }) => {
  return (
    <div
      className={classNames(styles.container, isDarkMode && styles.darkMode)}
      style={{
        backgroundImage: isDarkMode ? null : `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <p className={styles.title}>
        На жаль, <br></br>вік не підтверджено:(
      </p>
      <p className={styles.description}>
        Повернися на попередній крок і спробуй<br></br> пройти перевірку віку
        знову!
      </p>
      <button onClick={backButtonClick}>
        {isDarkMode && <img src="/images/gold-button.png" alt="gold-button" />}
        <span>Назад</span>
      </button>
    </div>
  );
};

export default YoungAgeScreen;
